import { Box } from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { WsColors, WsTypography } from 'wisestep-base';

import { CustomNoRowsOverlay } from '../../../../composableAnalytics/helper/showCustomizeNoDataTextDataGrid';
import { useNewCandidatePostgresWidgetData } from '../hooks/useNewCandidatePostgresWidgetData';
import { IPostgreNewCandidateDTO } from '../types/postgreNewCandidateDTO';
import { INewCandidateWidgetProp } from '../types/postgreNewCandidateWidgetProp';
import {
  defaultNewCandidateWidgetData,
  getNewCandidateTableData,
} from '../utils/newCandidateHelper';

const NewCandidateTablePostgres = ({ query, title, widgetName }: INewCandidateWidgetProp) => {
  const widgetData = useNewCandidatePostgresWidgetData<IPostgreNewCandidateDTO>(
    query,
    defaultNewCandidateWidgetData
  );
  const [rows, columns] = getNewCandidateTableData(widgetName, widgetData);

  return (
    <Box>
      <WsTypography bold={true}>{title}</WsTypography>
      <Box mt={1.5} style={{ height: 670, background: WsColors.White }}>
        <DataGrid
          columns={columns}
          rows={rows}
          components={{ Toolbar: GridToolbar, NoRowsOverlay: CustomNoRowsOverlay }}
          pageSize={10}
          rowsPerPageOptions={[10]}
          initialState={{
            sorting: {
              sortModel: [{ field: 'count', sort: 'desc' }],
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default NewCandidateTablePostgres;
